import MobileWrapper from "src/components/layout/mobile/mobile-wrapper"
import TransferForm from "../form"

const MobileTransfer = () => {
  return (
    <MobileWrapper toolBar={true} toolbarTitle='انتقال اعتبار'>
      <TransferForm isMobile={true} />
    </MobileWrapper>
  )
}

export default MobileTransfer
